import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { readNotification } from '../../services';
import { getNotificationsInfiniteQueryKey } from '../keys';

export const useReadNotificationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, string>({
    async mutationFn(id) {
      await readNotification({ routeParams: { id } });
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getNotificationsInfiniteQueryKey({}) });
    },
  });
};
